/**
 * Pagina prodotto, pallini colore (blocks/gf-color-siblings.liquid, snippets/gf-color-swatches.liquid):
 * passando sopra un pallino o arrivandoci con la tastiera, l'etichetta «Colore: X» mostra quel colore.
 * I pallini e i link li stampa il tema dai dati del catalogo: senza questo script funziona tutto lo stesso.
 */
class GfColori extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const signal = this.#abort.signal;
    const label = this.querySelector('[data-gf-colori-name]');
    if (!label) return;
    const original = label.textContent;
    const show = (event) => {
      const link = event.target.closest?.('[data-color]');
      if (link) label.textContent = link.dataset.color;
    };
    const reset = (event) => {
      if (event.target.closest?.('[data-color]')) label.textContent = original;
    };
    this.addEventListener('pointerover', show, { signal });
    this.addEventListener('focusin', show, { signal });
    this.addEventListener('pointerout', reset, { signal });
    this.addEventListener('focusout', reset, { signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }
}

if (!customElements.get('gf-colori')) customElements.define('gf-colori', GfColori);
